import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box, Collapse, IconButton, Typography } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import * as React from "react";
import GlassCard from "../GlassCard";
import Board from "./Board";
import DemoLayout from "./DemoLayout";

export default function SudokuPage() {
  const isMobile = useMediaQuery("(max-width: 700px)");
  const [expanded, setExpanded] = React.useState(!isMobile);

  return (
    <DemoLayout title="Sudoku Solver">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 3,
        }}
      >
        <Box sx={{ width: "100%", maxWidth: { xs: "100%", md: "66.67%" } }}>
          <GlassCard>
            <Typography
              variant={isMobile ? "h6" : "h5"}
              color="secondary"
              sx={{ fontFamily: "Roboto", fontWeight: 700, mb: 2 }}
            >
              Sudoku Solver · Backtracking Algorithm
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: "rgba(255,255,255,0.85)",
                fontFamily: "RobotoLight",
                fontWeight: 300,
                lineHeight: 1.8,
                mb: 1,
              }}
            >
              <a
                href="https://en.wikipedia.org/wiki/Sudoku"
                target="_blank"
                rel="noreferrer"
                style={{ color: "#85e0ff" }}
              >
                Sudoku
              </a>{" "}
              puzzles can be solved by a few algorithms — including
              backtracking. This method guarantees a solution even for the most
              difficult puzzles, as long as the board is valid.
            </Typography>

            {isMobile && (
              <IconButton
                onClick={() => setExpanded(!expanded)}
                sx={{ color: "rgba(255,255,255,0.85)", p: 0.5, mb: 0.5 }}
              >
                <ExpandMoreIcon
                  sx={{
                    transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.3s",
                  }}
                />
              </IconButton>
            )}

            <Collapse in={expanded} timeout="auto" unmountOnExit>
              <Box sx={{ mt: 1 }}>
                <Typography
                  variant="body2"
                  sx={{
                    color: "rgba(255,255,255,0.85)",
                    fontFamily: "Roboto",
                    fontWeight: 500,
                    mb: 0.5,
                  }}
                >
                  How does it work?
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "rgba(255,255,255,0.85)",
                    fontFamily: "RobotoLight",
                    fontWeight: 300,
                    lineHeight: 1.75,
                  }}
                >
                  Start from the top-left cell. Try digits 1–9. If a digit
                  doesn't break any constraint (row, column, 3×3 box), place it
                  and move on. If no digit works, backtrack to the previous cell
                  and continue. Repeat until solved.
                </Typography>
              </Box>
            </Collapse>
          </GlassCard>
        </Box>

        <Box sx={{ width: "100%", maxWidth: { xs: "100%", md: "66.67%" } }}>
          <GlassCard sx={{ overflowX: "auto" }}>
            <Board isMobile={isMobile} />
          </GlassCard>
        </Box>
      </Box>
    </DemoLayout>
  );
}
